import { BpPage } from "@/components/bp/bpPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vorschlag/$bestellvorschlagId")({
  component: BpPage,
});
